<div class="flex"
     [ngStyle]="{height: height+'px'}">
    <div [ngStyle]="{backgroundColor: cuerpo?.fondoColor, color: cuerpo?.textoColor}"
         class="flex-1">
        <div class="m-4">
            <h3>{{cuerpo?.texto}}</h3>
        </div>
    </div>
    <div class="flex align-content-center"
         *ngIf="logoDerecha?.show"
         [ngStyle]="{backgroundColor: logoDerecha?.fondoColor, width: logoDerecha?.width}">
        <div class="flex align-items-center justify-content-center m-2">
            <a [href]="logoDerecha?.href"
               target="_blank"
               *ngIf="logoDerecha?.href">
                <img [src]="logoDerecha?.pathIcon"
                     width="95%"
                     [alt]="logoDerecha?.textoIcon">
            </a>
            <img *ngIf="!logoDerecha?.href"
                 [src]="logoDerecha?.pathIcon"
                 width="95%"
                 [alt]="logoDerecha?.textoIcon">
        </div>
    </div>
</div>
